<i18n src="@/locales/modules/UserSettingsTranslate.json"></i18n>

<template>
	<vx-card no-shadow class="user-notifications py-0" id="user-notifications">
		<vs-table :data="notificationSettings" class="parent-table user-notifications__parent-table">
			<template slot="thead">
				<vs-th class="hidden lg:inline-block w-1/2"></vs-th>
				<vs-th class="hidden lg:inline-block w-1/4 text-lg">{{ $t("EmailNotification") }}</vs-th>
				<vs-th class="hidden lg:inline-block w-1/4 text-lg">{{ $t("AppNotification") }}</vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data" class="parent-table__row block mb-3">
					<td colspan="3" class="p-0 block">
						<h3 class="uppercase text-lg font-medium">{{ tr.group_name }}</h3>
						<vs-table :data="tr.items" class="stack-table">
							<template slot-scope="{ data }">
								<vs-tr
									:key="indextr"
									v-for="(tr, indextr) in data"
								>
									<vs-td class="w-full lg:w-1/2">{{ tr.name }}</vs-td>
									<vs-td class="w-full lg:w-1/4" :data-header="$t('EmailNotification')">
										<vs-switch color="success" class="mx-auto" v-model="tr.send_email" />
									</vs-td>
									<vs-td class="w-full lg:w-1/4" :data-header="$t('AppNotification')">
										<vs-switch color="success" class="mx-auto" v-model="tr.send_notification" />
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</td>
				</vs-tr>
			</template>
		</vs-table>

		<!-- Save & Reset Button -->
		<div class="flex flex-wrap items-center sm:justify-end">
			<vs-button class="w-full sm:w-1/3 sm:max-w-xs mt-4 font-bold" @click="saveChanges">{{ $t("Actions.SaveChanges") }}</vs-button>
		</div>
	</vx-card>
</template>

<script>
import profileGQL from "@/http/requests/inside/profile_gql";
import notificationGQL from "@/http/requests/link/notifications_gql";

export default {
	data() {
		return {
			notificationSettings: []
		};
	},
	methods: {
		getFormatData(notificationSettings) {
			const data = {};
			notificationSettings.forEach(groupSetting => (groupSetting.items || []).forEach(itemSetting => {
				data[itemSetting.key_email] = itemSetting.send_email;
				data[itemSetting.key_notification] = itemSetting.send_notification;
			}));
			return data;
		},
		async getNotificationSettings() {
			try {
				this.showLoading();
				this.notificationSettings = await notificationGQL.fetchNotificationSettings();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.hideLoading());
			}
		},
		showLoading() {
			this.$vs.loading({
				container: "#user-notifications",
				scale: 0.6
			});
		},
		hideLoading() {
			this.$vs.loading.close("#user-notifications > .con-vs-loading");
		},
		async saveChanges() {
			try {
				this.showLoading();
				await profileGQL.updateUserSettings({ settings: JSON.stringify({ notifications: this.getFormatData(this.notificationSettings) })});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("UpdateConfigSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.hideLoading());
			}
		},
	},
	mounted() {
		this.getNotificationSettings();
	}
};
</script>

<style lang="scss" scoped>
.user-notifications {
	::v-deep .vx-card__body {
		padding: 0 1.5rem;
	}

	.user-notifications__parent-table {
		::v-deep table {
			min-width: initial;
		}

		&.vs-con-table .vs-table--thead th {
			padding: 10px 15px !important;
		}

		.parent-table__row {
			transform: none !important;
		}

		tr {
			box-shadow: none !important;

			&:not(.parent-table__row):hover {
				box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.1) !important;
			}
		}

		::v-deep .vs-table-text {
			text-align: center;
			justify-content: center;
		}
	}
}
</style>
